import CreateIrosIndicators from "./CreateIrosIndicators";

export default CreateIrosIndicators;